import { render, staticRenderFns } from "./ChartingWorkspaceWorkspacesDialog.vue?vue&type=template&id=4213cbc8&scoped=true&"
import script from "./ChartingWorkspaceWorkspacesDialog.vue?vue&type=script&lang=js&"
export * from "./ChartingWorkspaceWorkspacesDialog.vue?vue&type=script&lang=js&"
import style0 from "./ChartingWorkspaceWorkspacesDialog.vue?vue&type=style&index=0&id=4213cbc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4213cbc8",
  null
  
)

export default component.exports